module.exports = __webpack_public_path__ + "img/curved-line.ffa4f8c4.svg";